import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./MainMenu.scss";

const MainMenu = () => {
  const navigate = useNavigate();

  return (
    <div className="main-menu">
      <div className="background-overlay">
        <Container>
          <h1 className="menu-title">My Table Topia</h1>
          <Row className="menu-options justify-content-center">
            <Col xs={10} md={4}>
              <Card
                className="menu-card"
                onClick={() => navigate("/collection")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body>
                  <Card.Title>📚 Sammlung</Card.Title>
                  <Card.Text>Verwalte und erstelle deine Karten</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={10} md={4}>
              <Card
                className="menu-card"
                onClick={() => navigate("/decks")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body>
                  <Card.Title>🃏 Decks</Card.Title>
                  <Card.Text>Erstelle und bearbeite deine Decks</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={10} md={4}>
              <Card
                className="menu-card"
                onClick={() => navigate("/rules")}
                style={{ cursor: "pointer" }}
              >
                <Card.Body>
                  <Card.Title>📜 Regelwerk</Card.Title>
                  <Card.Text>Alle Regeln auf einen Blick</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default MainMenu;
